import { Product } from 'models';

export class ProductSource {
  private products: object;

  public constructor(products: object) {
    this.products = products;
  }

  public getProducts(programName: string): Product[] {
    if (this.products && programName in this.products) {
      return this.products[programName];
    } else {
      return [];
    }
  }
}
